import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../utils/constants';
import { UserProfileMenu } from './UserManagement';

const REIFY_LOGO = 'https://customer-assets.emergentagent.com/job_dbd68d1b-28e6-42d0-902a-82a09fb5a2e9/artifacts/65npxqdg_atdzxq91_ChatGPT%20Image%20Mar%2018%2C%202026%2C%2008_54_02%20AM.png';

const GearsLandingPage = ({ onNavigate, currentUser, onLogout }) => {
  const allGears = [
    { id: 'production', name: 'PRODUCTION', description: 'Field operations & job management', color: 'from-orange-500 to-orange-600', isActive: true },
    { id: 'management', name: 'MANAGEMENT', description: 'Executive operations & oversight', color: 'from-indigo-500 to-indigo-600', isActive: true },
    { id: 'human-resources', name: 'HUMAN RESOURCES', description: 'Personnel management & HR', color: 'from-purple-500 to-purple-600', adminOnly: true, isActive: true },
    { id: 'sales', name: 'SALES', description: 'Business development & sales', color: 'from-red-500 to-red-600', isActive: true },
    { id: 'customer-care', name: 'CUSTOMER CARE', description: 'Customer support & relations', color: 'from-blue-500 to-blue-600', isActive: true },
    { id: 'engineering', name: 'ENGINEERING', description: 'Technical solutions & development', color: 'from-gray-500 to-gray-600', isActive: true },
    { id: 'training', name: 'TRAINING', description: 'Training modules & completion tracking', color: 'from-emerald-500 to-emerald-600', isActive: true },
  ];

  const GEAR_ICONS = {
    production: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" /></svg>,
    management: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>,
    'human-resources': <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
    sales: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
    'customer-care': <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" /></svg>,
    engineering: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
    training: <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path d="M12 14l9-5-9-5-9 5 9 5z" /><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" /></svg>,
  };

  // Company modules gate + user role/allowedGears gate
  const companyModules = currentUser?.company?.modules_enabled || [];

  const gears = allGears.filter(gear => {
    // Gate 1: Company must have the module enabled
    if (companyModules.length > 0 && !companyModules.includes(gear.id)) return false;

    // Gate 2: Admin sees all enabled modules
    if (currentUser?.rawRole === 'admin') return true;

    // Gate 3: Employee allowed gears
    const allowed = currentUser?.allowedGears;
    if (Array.isArray(allowed)) return allowed.includes(gear.id);

    // Default for employees without allowedGears
    return ['production', 'training'].includes(gear.id);
  });

  const company = currentUser?.company;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white text-gray-800 relative" data-testid="gears-landing-page">
      {/* User Profile Menu */}
      <div className="absolute top-4 right-4 z-10">
        <UserProfileMenu currentUser={currentUser} onLogout={onLogout} />
      </div>
      
      <div className="container mx-auto px-4 py-8">
        {/* Header — dynamic company branding */}
        <div className="text-center mb-12">
          <div className="flex flex-col items-center justify-center mb-6">
            {company?.logo_url ? (
              <img 
                src={company.logo_url} 
                alt={`${company.name} Logo`}
                className="h-20 sm:h-24 md:h-28 mb-4 object-contain"
                data-testid="company-logo"
              />
            ) : (
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-testid="company-name-header">
                {company?.name || 'Operations Hub'}
              </h1>
            )}
          </div>
          <p className="text-lg sm:text-xl text-gray-600 mb-2">Operations Hub</p>
          <p className="text-sm text-gray-500">Select your department to access specialized tools</p>
        </div>

        {/* Gears Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {gears.map((gear) => (
            <div 
              key={gear.id}
              className={`bg-gradient-to-r ${gear.color} rounded-xl p-8 cursor-pointer transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl text-white relative overflow-hidden`}
              onClick={() => onNavigate(gear.id)}
              data-testid={`gear-card-${gear.id}`}
            >
              <div className="relative text-center">
                <div className="flex justify-center mb-4 opacity-90">
                  {GEAR_ICONS[gear.id] || <svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 6h16M4 12h16M4 18h16" /></svg>}
                </div>
                <h2 className="text-xl font-bold mb-2">{gear.name}</h2>
                <p className="text-white/80 text-sm leading-relaxed">{gear.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Administrative Controls - Admin Only */}
        {currentUser?.rawRole === 'admin' && (
          <div className="mt-16 max-w-7xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-xl font-bold text-gray-800 mb-1">Administrative Controls</h2>
              <p className="text-sm text-gray-500">System-wide administrative functions</p>
            </div>
            
            <div className="flex justify-center gap-4 flex-wrap">
              <AdminCard
                icon={<svg className="w-10 h-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
                title="USER MANAGEMENT"
                subtitle="System users & access control"
                gradient="from-red-500 to-red-600"
                onClick={() => onNavigate('user-management')}
                testId="user-management-card"
              />

              <AdminCard
                icon={<svg className="w-10 h-10 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
                title="COMPANY SETTINGS"
                subtitle="Branding, contact info & email"
                gradient="from-amber-500 to-amber-600"
                onClick={() => onNavigate('company-settings')}
                testId="company-settings-card"
              />
            </div>
          </div>
        )}

        {/* Company Information Footer */}
        <div className="mt-16 border-t border-gray-200 pt-8">
          <div className="text-center">
            <div className="mb-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4">{company?.name || 'Your Company'}</h3>
              <div className="space-y-2 text-gray-600 text-sm">
                {company?.address && (
                  <p className="flex items-center justify-center gap-2">
                    <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                    {company.address}
                  </p>
                )}
                {company?.phone && (
                  <p className="flex items-center justify-center gap-2">
                    <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                    <a href={`tel:${company.phone}`} className="hover:text-blue-600 transition-colors">{company.phone}</a>
                  </p>
                )}
                {company?.email && (
                  <p className="flex items-center justify-center gap-2">
                    <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                    <a href={`mailto:${company.email}`} className="hover:text-blue-600 transition-colors">{company.email}</a>
                  </p>
                )}
                {company?.website && (
                  <p className="flex items-center justify-center gap-2">
                    <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" /></svg>
                    <a href={company.website} target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 transition-colors">{company.website.replace(/^https?:\/\//, '')}</a>
                  </p>
                )}
              </div>
            </div>
            
            <div className="text-xs text-gray-400 border-t border-gray-100 pt-4">
              <span>&copy; {new Date().getFullYear()} {company?.name || 'Your Company'}. All rights reserved.</span>
              <span className="mx-2">|</span>
              <span>Powered by <span className="font-medium">Reify Systems</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function AdminCard({ icon, title, subtitle, gradient, onClick, testId, badge }) {
  return (
    <div 
      className={`bg-gradient-to-r ${gradient} rounded-xl p-8 cursor-pointer transform hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl text-white relative overflow-hidden max-w-sm w-full sm:w-72`}
      onClick={onClick}
      data-testid={testId}
    >
      <div className="relative text-center">
        <div className="mb-4 flex justify-center opacity-90">{icon}</div>
        <h3 className="text-lg font-bold mb-1">{title}</h3>
        <p className="text-white/80 text-sm">{subtitle}</p>
        {badge && (
          <div className="mt-3 bg-white/20 text-white text-xs px-3 py-1 rounded-full font-medium inline-block">
            {badge}
          </div>
        )}
      </div>
    </div>
  );
}

const ComingSoonPage = ({ gear, onBackToGears }) => {
  const gearInfo = {
    'accounting': { name: 'Accounting', description: 'Financial management & reporting systems' },
    'customer-care': { name: 'Customer Care', description: 'Customer support & relations management' },
    'engineering': { name: 'Engineering', description: 'Technical solutions & development tools' },
    'management': { name: 'Management', description: 'Executive operations & oversight dashboards' },
    'marketing': { name: 'Marketing', description: 'Brand promotion & advertising tools' },
    'sales': { name: 'Sales', description: 'Business development & sales management' },
    'service': { name: 'Service', description: 'Customer service & support systems' }
  };

  const info = gearInfo[gear] || { name: 'Unknown', description: 'Department systems' };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-white flex items-center justify-center">
      <div className="text-center max-w-md mx-4">
        <svg className="w-16 h-16 mx-auto mb-6 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
        <h1 className="text-3xl font-bold text-gray-800 mb-3">{info.name}</h1>
        <p className="text-lg text-gray-600 mb-6">{info.description}</p>
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-5 mb-6">
          <p className="text-amber-800 font-medium text-sm">Coming Soon</p>
          <p className="text-amber-600 text-xs mt-1">This module is under development.</p>
        </div>
        <button
          onClick={onBackToGears}
          className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-colors"
          data-testid="coming-soon-back-btn"
        >
          Back to Gears
        </button>
      </div>
    </div>
  );
};

export { GearsLandingPage, ComingSoonPage };
